
import React from 'react';

import IsknExplorerPageState from './IsknExplorerPage.state';

const IsknExplorerPage = (props) => {

    return (
        <IsknExplorerPageState
            match={props.match}
        />
    )
}

export default IsknExplorerPage;
